import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

export default function CreateFootprint() {

  const navigate = useNavigate();

  const [locationName, setLocationName] =
    useState("");

  const [note, setNote] =
    useState("");

  async function saveFootprint() {

    try {

      const user = JSON.parse(
        localStorage.getItem("user")
      );

      const { data } =
  await api.post(
    "/footprints",
    {
      userId: user.id,
      locationName,
      note
    }
  );

alert("Footprint created");

navigate(
  `/location/${data.location.id}`
);

    } catch (err) {

      console.error(err);

      alert(
        "Failed to create footprint"
      );

    }

  }

  return (
    <div className="page">

      <h2>
        📍 Leave Footprint
      </h2>

      <input
        type="text"
        placeholder="Place Name"
        value={locationName}
        onChange={(e) =>
          setLocationName(e.target.value)
        }
      />

      <br />
      <br />

      <textarea
        placeholder="Write something..."
        value={note}
        onChange={(e) =>
          setNote(e.target.value)
        }
      />

      <br />
      <br />

      <button
        onClick={saveFootprint}
      >
        Save Footprint
      </button>

    </div>
  );

}